<template>
    <div>
        <!-- Cancelamento Item Modal -->
        <div class="modal fade" id="cancAtendProcModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true" style="z-index:1000000000">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="atp">
                    <div class="modal-header">
                        <h5 class="modal-title">Cancelar Procedimento</h5>
                        <button type="button" class="close" @click="fechar()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-danger">
                            <div class="lead" v-if="atp && atp.procedimento">{{ atp.procedimento ? atp.procedimento.search : '?' }}</div>
                            Confirma realizar o cancelamento do procedimento?
                        </div>

                        <div class="row" v-if="motivos && motivos.length">
                            <div class="col col-12">
                                <az-input
                                    label="Motivo"
                                    type="select"
                                    :optionsList="motivos"
                                    optionsData="id_motivo"
                                    required 
                                    :validate="validate"
                                    v-model="id_motivo" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Observações"
                                    type="textarea"
                                    rows="3"
                                    v-model="observacao" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar()">Fechar</button>
                        <az-submit color="danger" @click="atualizar()">Realizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzSubmit from '../../util/AzSubmit.vue';
import AzInput from '../../shared/forms/AzInput.vue';

export default {
    data() { 
        return { 
            atp: null, 
            origem: null, 
            observacao: '',
            motivos: null, 
            callback: null, 
            validate: false, 
            id_motivo: "", 
        }; 
    },
    
    components: { 
        AzSubmit, 
        AzInput, 
    },

    methods: { 
        obter_canc_motivos () { 
            this.$util.loadItem(this, { 
                service: 'guias',
                func: 'obter_canc_motivos',
            })
            .then(res => { 
                if ( res && res.lista ) { 
                    this.motivos = res.lista;
                }
            });
        },

        cancelar (atp, canc_motivos, callback) { 

            if ( canc_motivos === null && this.motivos === null ) { 
                this.motivos = []; 
                this.obter_canc_motivos();
            } else { 
                this.motivos = canc_motivos;
            }

            this.validate = false;
            
            
            if ( !this.origem || this.origem.id_atendimento != atp.id_atendimento ) { 
                this.observacao = "";
                this.id_motivo = "";
            }

            this.origem = atp;
            this.callback = callback;
            this.atp = _.cloneDeep(atp);
            
            $('#cancAtendProcModal').modal('show');
        },

        fechar () { 
            $('#cancAtendProcModal').modal('hide');
        },

        atualizar() { 
            if ( !this.callback ) { 
                alert('Chamada de retorno não definida.');
                return;
            }

            this.validate = true;

            this.$nextTick(() => { 

                let invalids = $("#cancAtendProcModal .invalid");

                if (invalids.length && $(".invalid").is(":visible")) {
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Verificar preenchimento dos campos.",
                        life: 3000
                    });
                    return;
                }

                this.origem.canc_id_motivo = this.id_motivo;
                this.origem.canc_obs = this.observacao;

                this.fechar();

                this.callback(this.origem, false);

            });
        },
    }
}
</script>